/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useNavigate,Navigate } from "react-router-dom";
import {useFormik} from 'formik'
import {getUserByToken, signup} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {Link} from 'react-router-dom'
import { GoogleLogin , GoogleLogout} from 'react-google-login'
import { gapi } from 'gapi-script'


const loginSchema = Yup.object().shape({
   name : Yup.string()
   .min(3, 'Minimum 3 symbols')
   .max(50, 'Maximum 50 symbols')
   .required('First name is required'),
   email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
//   password: Yup.string()
//     .min(3, 'Minimum 3 symbols')
//     .max(50, 'Maximum 50 symbols')
//     .required('Password is required'),
})

const initialValues = {
    name:"admin",
    email: 'admin@demo.com'
  
}
  


/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function SignUp() {
  const navigate = useNavigate();

  const [ profile, setProfile ] = useState<any>([]);
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()



 

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
     
        const {data: auth} = await signup(values.name,values.email)
   
        saveAuth(auth)
        console.log("data",auth);
         navigate("/auth/registration-page")
        // const {data: user} = await getUserByToken(auth.api_token)
        // setCurrentUser(user)
       
      } catch (error) {
        navigate("/auth/registration-page")
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })


  const clientId = '771321969228-26pdlmttljkpga8qv1ka6ilfmct7jp4f.apps.googleusercontent.com';
  useEffect(() => {
    const initClient = () => {
          gapi.client.init({
          clientId: clientId,
          scope: ''
          
        });
     };
     gapi.load('client:auth2', initClient);
    
    },[]);

    const onSuccess = (res:any) => {
      let data ={
        email: res.profileObj.email,
       name :res.profileObj.givenName,
       imgURL :res.profileObj.imageUrl
         }
   
        console.log("data",data);
        setProfile(data);
       navigate('/auth/registration-page' )

  };
  const onFailure = (err:any) => {  
      console.log('failed:', err);
  };
   
 
  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_sign_in_submit'
    >
      {/* begin::Heading */}
      
    
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Sign Up</h1>
      </div>

      <div className='text-gray-500 text-center fw-semibold fs-6'>
        
           <GoogleLogin
          clientId={clientId}
          buttonText="Sign up with Google"
          onSuccess={onSuccess}
          onFailure={onFailure}
          cookiePolicy={'single_host_origin'}
          //isSignedIn={true}
      />
      </div>
      
      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div>
    
        <div className='fv-row mb-8'>
        {/* begin::Form group name */}
        <label className='form-label fw-bolder text-dark fs-6'>Name</label>
        <input
          placeholder='Name'
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('name')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.name && formik.errors.name,
            },
            {
              'is-valid': formik.touched.name && !formik.errors.name,
            }
          )}
        />
        {formik.touched.name && formik.errors.name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.name}</span>
            </div>
          </div>
        )}
        {/* end::Form group */}
      </div>



      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
          </div>
        )}
      </div>
      {/* end::Form group */}


 
        
      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <div className='d-grid mb-10'>
        <Link to='/auth/login'>
       
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mt-5 mb-5'
         >
            Cancel
          </button>
        </Link>
        </div>
      </div>
      {/* end::Action */}
    
    </form>
  )
}
